import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

import InfoItem from "./InfoItem";
import SocialIcon from "./SocialIcon";

const ContactInfo = ({ data, isAR }) => {
  return (
    <aside className="text-primary flex flex-col justify-between bg-gradient-to-br from-[#DCE8F9] via-[#DFEAFA] to-[#FFFFFF] p-10 md:col-span-2">
      <div>
        <h3 className="text-dark mb-2 text-2xl font-semibold">
          {data?.info?.title}
        </h3>

        <p className="mb-12 text-gray-500">{data?.info?.description}</p>

        <div className="space-y-6">
          <InfoItem icon={FaPhoneAlt} {...data?.info?.details?.phone} />

          <InfoItem icon={FaEnvelope} {...data?.info?.details?.email} />

          <InfoItem icon={FaMapMarkerAlt} {...data?.info?.details?.address} />
        </div>
      </div>

      {/* Social */}
      <div className="mt-10">
        <p className="text-dark mb-3 text-sm">
          {isAR ? "تابعنا" : "Follow us"}
        </p>

        <div className="flex gap-3">
          <SocialIcon href={data?.info?.social?.facebook} Icon={FaFacebookF} />

          <SocialIcon href={data?.info?.social?.linkedin} Icon={FaLinkedinIn} />
        </div>
      </div>
    </aside>
  );
};

export default ContactInfo;
